import { useState } from "react";
import { modelNameMap } from "../utils/modelNameMap";
import { Link, useLoaderData } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import Modal from "../components/Modal";
import { SingleCarproposal } from "../components/SingleCarProposal";
import { SingleCartestdrive } from "../components/SingleCarTestdrive";
import { hotlist } from "../constants/hotlist";
import { specialPriceList } from "../constants/specialPriceList";

export default function CarDetails() {
  const specialPriceIds = new Set(specialPriceList);

  const car = useLoaderData();

  const displayModel = modelNameMap[car.model.toUpperCase()] || car.model;
  document.title = "FORD " + displayModel + " " + car.id;

  // Функция за конвертиране на кирилица в латиница
  function convertCyrillicToLatin(text) {
    return text
      .replaceAll("й", "i")
      .replaceAll("ц", "ts")
      .replaceAll("у", "u")
      .replaceAll("к", "k")
      .replaceAll("е", "e")
      .replaceAll("н", "n")
      .replaceAll("г", "g")
      .replaceAll("ш", "sh")
      .replaceAll("щ", "sht")
      .replaceAll("з", "z")
      .replaceAll("х", "h")
      .replaceAll("ъ", "a")
      .replaceAll("ф", "f")
      .replaceAll("в", "v")
      .replaceAll("а", "a")
      .replaceAll("п", "p")
      .replaceAll("р", "r")
      .replaceAll("о", "o")
      .replaceAll("л", "l")
      .replaceAll("д", "d")
      .replaceAll("ж", "zh")
      .replaceAll("я", "ya")
      .replaceAll("ч", "ch")
      .replaceAll("с", "s")
      .replaceAll("м", "m")
      .replaceAll("и", "i")
      .replaceAll("т", "t")
      .replaceAll("б", "b")
      .replaceAll("ю", "yu");
  }

  let imageSource =
    "/images/" +
    encodeURIComponent(
      convertCyrillicToLatin(
        displayModel
          .toLowerCase()
          .replaceAll(/\s/g, "")
          .replaceAll(/-/g, "")
          .replaceAll(/\//g, ""),
      ),
    ) +
    "-" +
    encodeURIComponent(
      convertCyrillicToLatin(
        car.body
          .toLowerCase()
          .replaceAll(/\s/g, "")
          .replaceAll(/-/g, "")
          .replaceAll(/\//g, ""),
      ),
    ) +
    "-" +
    encodeURIComponent(
      convertCyrillicToLatin(
        car.trim
          .toLowerCase()
          .replaceAll(/\s/g, "")
          .replaceAll(/-/g, "")
          .replaceAll(/\//g, ""),
      ),
    ) +
    "-" +
    encodeURIComponent(
      convertCyrillicToLatin(
        car.color
          .toLowerCase()
          .replaceAll(/\s/g, "")
          .replaceAll(/-/g, "")
          .replaceAll(/\//g, ""),
      ),
    ) +
    ".jpeg";

  let discount = ((car.old_price - car.new_price) / car.old_price) * 100;

  const [showModal, setShowModal] = useState(false);
  const [proposal, setProposal] = useState(false);
  const [testdrive, setTestdrive] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setProposal(false);
    setTestdrive(false);
  };
  const requestProposal = () => {
    setShowModal(true);
    setProposal(true);
    window.scrollTo(0, 0);
  };

  const requestTestdrive = () => {
    setShowModal(true);
    setTestdrive(true);
    window.scrollTo(0, 0);
  };

  const placeholderImage = "/images/default-car.jpg";
  const onImageError = (e) => {
    e.target.src = placeholderImage;
    console.log("Грешка при зареждане на изображението: ", e.target.src);
  };

  // Логика за бутона Всичко за модела
  let href;

  switch (car.model.toLowerCase()) {
    case "courier":
      href = "https://ford.bg/commercial_cars/new-transit-courier";
      break;
    case "puma gen-e":
      href = "https://ford.bg/cars/puma-gen-e";
      break;
    case "tourneocon":
      href = "https://ford.bg/cars/tourneo-connect";
      break;
    case "custom transit ice":
      href = "https://ford.bg/commercial_cars/new-custom";
      break;
    case "connect transit ice":
      href = "https://ford.bg/commercial_cars/new-transit-connect";
      break;
    case "courier transit ice":
      href = "https://ford.bg/commercial_cars/new-transit-courier";
      break;
    case "connect":
      href = "https://ford.bg/commercial_cars/new-transit-connect";
      break;
    case "puma":
      href = "https://ford.bg/cars/new-puma";
      break;
    case "puma-gen-e":
      href = "https://ford.bg/cars/puma-gen-e";
      break;
    case "focus":
      href = "https://ford.bg/cars/focus";
      break;
    case "new kuga":
      href = "https://ford.bg/cars/kuga-2026";
      break;
    case "new custom":
      href = "https://ford.bg/commercial_cars/new-custom";
      break;
    case "custom":
      href = "https://ford.bg/commercial_cars/new-custom";
      break;
    case "tourneo connect":
      href = "https://ford.bg/cars/tourneo-connect";
      break;
    case "transit":
      href = "https://ford.bg/commercial_cars/transit";
      break;
    case "kuga":
      href = "https://ford.bg/cars/kuga-2026";
      break;
    case "ranger":
      href = "https://ford.bg/commercial_cars/new-ranger";
      break;
    case "ranger-phev":
      href = "https://ford.bg/commercial_cars/new-ranger";
      break;
    case "mach-e":
      href = "https://ford.bg/cars/mustang-mach-e";
      break;
    case "mustang":
      href = "https://ford.bg/cars/new-mustang";
      break;
    case "bronco":
      href = "https://ford.bg/cars/bronco";
      break;
    case "explorer":
      href = "https://ford.bg/cars/new-explorer";
      break;
    case "e-explorer":
      href = "https://ford.bg/cars/new-explorer";
      break;
    default:
      href = "https://ford.bg/cars/" + car.model.toLowerCase();
  }

  return (
    <div className="p-8">
      <div>
        <div className="flex justify-between">
          <div className="flex flex-col">
            <p className="text-sm">
              <Link to="/">&#x3c;&#x3c; обратно към всички оферти</Link>
            </p>
            <h1 className="mt-8 text-4xl uppercase text-fordBlue">
              FORD {car ? displayModel : `No such car`}
            </h1>
            <p className="text-sm">Оферта {car.id.toUpperCase()}</p>
          </div>
          {discount !== 0 && (
            <div
              className={`flex flex-col px-8 py-4 mt-auto text-center rounded-sm ${
                hotlist.includes(car.id) ? "bg-fordRed" : "bg-fordLight"
              }`}
            >
              <p className="tracking-widest text-white uppercase">
                {hotlist.includes(car.id)
                  ? "Ексклузивна оферта"
                  : "Специална оферта"}
              </p>
              <b className="tracking-widest text-center text-white uppercase">
                -
                {new Intl.NumberFormat("bg", {
                  maximumFractionDigits: 0,
                }).format(discount)}
                %
              </b>
              {!hotlist.includes(car.id) && (
                <p className="text-center text-white">
                  ДОПЪЛНИТЕЛЕН БОНУС ПРИ
                  <br />
                  ПОКУПКА ПРЕЗ МОТО-ПФОЕ ЛИЗИНГ
                </p>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 mt-16 lg:grid-cols-3">
        <div className="flex flex-col justify-between col-span-1">
          <div className="relative">
            {specialPriceIds.has(car.id) && (
              <div className="absolute top-0 right-0 w-[110px] h-[110px] overflow-hidden">
                <div className="absolute top-[28px] right-[-40px] w-[160px] rotate-45 bg-yellow-400 text-fordBlue text-sm font-semibold text-center shadow-md py-2">
                  Специална цена
                </div>
              </div>
            )}
            <img src={imageSource} alt="" onError={onImageError} />
          </div>
          <p className="text-xs text-gray-400">
            Изображението е с илюстративен характер. За да потвърдим наличността
            на избрания от Вас автомобил и Ви изпратим обвързваща оферта, моля,
            използвайте формата за запитване тук или се свържете с най-близкото
            представителство на Ford в България.
          </p>
        </div>
        <div className="self-center h-full col-span-1 px-6 border-l border-r">
          <div>
            <div className="flex justify-between p-2 py-4 border-b bg-gray-50">
              <p className="text-gray-500">Ниво на оборудване</p>
              <p className="uppercase text-fordBlue">{car.trim}</p>
            </div>
            <div className="flex justify-between p-2 py-4 border-b">
              <p className="text-gray-500">Гориво</p>
              <p className="uppercase text-fordBlue">{car.fuel}</p>
            </div>
            <div className="flex justify-between p-2 py-4 border-b bg-gray-50">
              <p className="text-gray-500">Двигател</p>
              <p className="uppercase text-fordBlue">{car.engine}</p>
            </div>
            <div className="flex justify-between p-2 py-4 border-b">
              <p className="text-gray-500">Каросерия</p>
              <p className="uppercase text-fordBlue">{car.body}</p>
            </div>
            <div className="flex justify-between p-2 py-4 border-b bg-gray-50">
              <p className="text-gray-500">Цвят</p>
              <p className="uppercase text-fordBlue">{car.color}</p>
            </div>
            <div className="flex justify-between p-2 py-4 border-b">
              <p className="text-gray-500">Задвижване</p>
              <p className="uppercase text-fordBlue">{car.drivetrain}</p>
            </div>
            <div className="flex justify-between p-2 py-4 border-b bg-gray-50">
              <p className="text-gray-500">Скоростна кутия</p>
              <p className="uppercase text-fordBlue">{car.gearbox}</p>
            </div>
            <div className="flex justify-between p-2 py-4 border-b">
              <p className="text-gray-500">Брой предавки</p>
              <p className="uppercase text-fordBlue">{car.gears}</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between col-span-1 pl-4">
          <div className="pt-8">
            {discount !== 0 && (
              <>
                <p className="text-end">Стара цена:</p>
                <p className="line-through text-end">
                  {new Intl.NumberFormat("bg", {
                    maximumFractionDigits: 0,
                  }).format(car.old_price)}{" "}
                  €
                </p>
              </>
            )}
            {discount !== 0 ? (
              <p className="text-end">Нова цена:</p>
            ) : (
              <p className="text-end">Цена:</p>
            )}
            <p className="mt-2 text-4xl text-end text-fordBlue">
              {new Intl.NumberFormat("bg", {
                maximumFractionDigits: 0,
              }).format(car.new_price)}{" "}
              <span className="text-2xl">€</span>
            </p>
            {discount !== 0 && (
              <p className="text-xl text-fordBlue text-end">
                Спестявате{" "}
                {new Intl.NumberFormat("bg", {
                  maximumFractionDigits: 0,
                }).format(car.old_price - car.new_price)}{" "}
                <span className="text-sm">€</span>
              </p>
            )}
          </div>

          <div className="pl-4 mt-4">
            <button
              className="w-full py-3 mt-8 btn-primary"
              onClick={requestProposal}
            >
              Попитайте за специалната ни оферта
            </button>
            <div className="flex flex-col justify-between gap-2 lg:flex-row">
              <button
                className="mt-4 btn-secondary grow"
                onClick={requestTestdrive}
              >
                Заявете тестдрайв
              </button>
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                className="mr-2 grow"
              >
                <button className="w-full mt-4 ml-2 btn-secondary">
                  Всичко за модела
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      {showModal && proposal && (
        <Modal handleClose={handleClose}>
          <h2 className="mt-8 text-xl text-center uppercase text-fordBlue">
            Попитайте за специалната ни оферта за автомобил Ford {displayModel}{" "}
            {car.id}
          </h2>
          <SingleCarproposal model={displayModel} ofertanomer={car.id} />
        </Modal>
      )}
      {showModal && testdrive && (
        <Modal handleClose={handleClose}>
          <h2 className="mt-8 text-xl text-center uppercase text-fordBlue">
            Попитайте за тестдрайв на автомобил Ford {displayModel}
          </h2>
          <SingleCartestdrive model={displayModel} ofertanomer={car.id} />
        </Modal>
      )}
    </div>
  );
}

export const carDetailsLoader = async ({ params }) => {
  const { id } = params;
  const docRef = doc(db, "cars", id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return null;
  }
};
